__turbopack_context__.v({
  "arrowBtn": "blogSection-module__Bwr3hG__arrowBtn",
  "blogSwiper": "blogSection-module__Bwr3hG__blogSwiper",
  "body": "blogSection-module__Bwr3hG__body",
  "card": "blogSection-module__Bwr3hG__card",
  "description": "blogSection-module__Bwr3hG__description",
  "excerpt": "blogSection-module__Bwr3hG__excerpt",
  "footerRow": "blogSection-module__Bwr3hG__footerRow",
  "grid": "blogSection-module__Bwr3hG__grid",
  "headerLeft": "blogSection-module__Bwr3hG__headerLeft",
  "headerRight": "blogSection-module__Bwr3hG__headerRight",
  "headerRow": "blogSection-module__Bwr3hG__headerRow",
  "image": "blogSection-module__Bwr3hG__image",
  "imageWrap": "blogSection-module__Bwr3hG__imageWrap",
  "navControls": "blogSection-module__Bwr3hG__navControls",
  "postTitle": "blogSection-module__Bwr3hG__postTitle",
  "readMoreBtn": "blogSection-module__Bwr3hG__readMoreBtn",
  "section": "blogSection-module__Bwr3hG__section",
  "seeAllLink": "blogSection-module__Bwr3hG__seeAllLink",
  "skeletonCard": "blogSection-module__Bwr3hG__skeletonCard",
  "tag": "blogSection-module__Bwr3hG__tag",
  "title": "blogSection-module__Bwr3hG__title",
});
